(() => {
  const drawer = document.querySelector('[data-za-cart-drawer]');
  if (!drawer) return;

  const discountStyle = document.createElement('style');
  discountStyle.textContent = `
    .za-cart-drawer__rec .za-cart-rec-price { display:flex; align-items:center; flex-wrap:wrap; gap:6px; }
    .za-cart-drawer__rec .za-cart-rec-discount { display:inline-block; flex:none; padding:3px 7px; border-radius:999px; background:#bd4937; color:#fff; font:700 10px/1.2 Arial,sans-serif; white-space:nowrap; }
  `;
  discountStyle.textContent += `
    .za-cart-drawer__item-main .za-drawer-unit-price { display:flex; align-items:center; flex-wrap:wrap; gap:4px; }
    .za-cart-drawer__item-main .za-drawer-regular, .za-cart-drawer__subtotal .za-drawer-regular { color:#91877b; font-size:11px; font-weight:400; white-space:nowrap; }
    .za-cart-drawer__item-main .za-drawer-current { color:#191510; white-space:nowrap; }
    .za-cart-drawer__item-main .za-drawer-discount { display:inline-flex; align-items:center; flex:none; padding:3px 5px; border-radius:999px; color:#fff; background:#b84a3a; font:700 10px/12px Arial,sans-serif; white-space:nowrap; }
    .za-cart-drawer__subtotal [data-za-cart-subtotal] { display:flex; justify-content:flex-end; align-items:baseline; flex-wrap:wrap; gap:7px; }
  `;
  drawer.appendChild(discountStyle);
  const root = window.Shopify?.routes?.root || '/';
  const panel = drawer.querySelector('.za-cart-drawer__panel');
  const body = drawer.querySelector('[data-za-cart-drawer-body]');
  const subtotal = drawer.querySelector('[data-za-cart-subtotal]');
  const subtotalLabel = drawer.querySelector('.za-cart-drawer__subtotal span');
  const footer = drawer.querySelector('[data-za-cart-drawer-footer]');
  const progress = drawer.querySelector('[data-za-cart-shipping-bar]');
  const initialCartData = drawer.parentElement?.querySelector('[data-za-cart-initial]');
  const mobileBuybar = document.querySelector('[data-za-mobile-buybar]');
  const triggers = () => document.querySelectorAll('[data-za-cart-drawer-open]');
  const cartReturnKey = 'zoalinCartReturnUrl';
  const desktopDrawerQuery = '(min-width: 761px)';
  const floatingPickerQuery = '(min-width: 1100px)';
  const fallbackRecommendationHandles = [
    'everyday-tunic-and-pants-set',
    'tailored-modest-two-piece-set',
    'graceful-button-maxi-dress',
    'soft-pleated-abaya-dress',
    'relaxed-modest-lounge-set',
  ];
  let isLoading = false;
  let hasRenderedCart = false; // ZOALIN_CART_THUMBNAIL_PRIORITY_20260905
  let recommendationProducts = [];
  const recommendationProductMap = new Map();

  const escapeHtml = (value = '') => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  const imageUrl = (source, width = 220) => {
    const url = typeof source === 'string' ? source : (source?.src || source?.url || '');
    if (!url) return '';
    if (url.includes('?')) return `${url}&width=${width}`;
    return `${url}?width=${width}`;
  };

  const trashIcon = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <path d="M3 6h18"></path>
      <path d="M8 6V4h8v2"></path>
      <path d="m6 6 1 15h10l1-15"></path>
      <path d="M10 11v6M14 11v6"></path>
    </svg>
  `;

  const isDesktopDrawer = () => {
    if (typeof window.matchMedia === 'function') return window.matchMedia(desktopDrawerQuery).matches;
    return window.innerWidth >= 761;
  };

  const isFloatingPicker = () => {
    if (typeof window.matchMedia === 'function') return window.matchMedia(floatingPickerQuery).matches;
    return window.innerWidth >= 1100;
  };

  const productImageUrl = (product, width = 220) => {
    const source = product?.featured_image || product?.images?.[0] || '';
    return imageUrl(source, width);
  };

  const currentProductByHandle = async (handle) => {
    if (!handle) return null;
    if (recommendationProductMap.has(handle)) return recommendationProductMap.get(handle);
    const product = await fetchProductByHandle(handle);
    if (product?.handle) recommendationProductMap.set(product.handle, product);
    return product;
  };

  const imageSourceText = (source) => String(
    typeof source === 'string' ? source : (source?.src || source?.url || ''),
  ).toLowerCase();

  const recommendationImageScore = (source) => {
    const text = imageSourceText(source);
    if (!text) return -1000;
    if (/size[-_]?chart|measurement|guide|backup|old|duplicate/.test(text)) return -1000;

    let score = 0;
    if (/lifestyle[-_]?realshot|realshot|lifestyle/.test(text)) score += 100;
    if (/scene|street|cafe|gallery|terrace|harbo[u]?r|coastal|palm|paris|courtyard|travel|outdoor|evening|beach|sea/.test(text)) score += 24;
    if (/front[-_]?studio|back[-_]?studio|studio|detail|flatlay/.test(text)) score -= 42;
    return score;
  };

  const recommendationImageUrl = (product, width = 220) => {
    // ZOALIN_CART_SCENES_20260909: numbered uploads identify scenes in media alt text.
    const sceneColors = {
      'relaxed-modest-lounge-set': 'Mocha',
      'soft-layered-modest-set': 'Camel',
      'tailored-modest-two-piece-set': 'Blue',
      'printed-flow-maxi-dress': 'Khaki Print',
      'abstract-print-tunic-pants-set': 'Apricot Print',
      'everyday-modest-tunic-set': 'Sage Green',
      'graceful-button-maxi-dress': 'Blue',
      'abstract-print-maxi-dress': 'Abstract Beige',
      'soft-pleated-abaya-dress': 'Black',
      'elegant-button-sleeve-tunic-pants-set': 'Ivory',
      'everyday-tunic-and-pants-set': 'Sage',
    };
    const preferredColor = sceneColors[product?.handle];
    const scenes = (Array.isArray(product?.media) ? product.media : [])
      .filter(media => media.media_type === 'image' && / - lifestyle/i.test(media.alt || ''));
    const scene = scenes.find(media => preferredColor && String(media.alt).toLowerCase().includes((' - ' + preferredColor + ' - lifestyle').toLowerCase())) || scenes[0];
    if (scene?.preview_image?.src) return imageUrl(scene.preview_image, width);

    const candidates = [product?.featured_image]
      .concat(Array.isArray(product?.images) ? product.images : [])
      .filter(Boolean)
      .map((source, index) => ({ source, index, score: recommendationImageScore(source) }))
      .filter((item) => item.score > 0)
      .sort((a, b) => b.score - a.score || a.index - b.index);

    return imageUrl(candidates[0]?.source, width) || productImageUrl(product, width);
  };

  const variantImageUrl = (product, variant, width = 520) => (
    imageUrl(variant?.featured_image || variant?.featured_media?.preview_image, width)
    || productImageUrl(product, width)
  );

  const variantPrice = (product, variant) => (
    variant?.price ?? product?.price ?? product?.price_min ?? 0
  );

  const productUrl = (product) => product?.url || (product?.handle ? `${root}products/${product.handle}` : '#');

  const firstAvailableVariant = (product) => {
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    return variants.find((variant) => variant.available !== false) || variants[0] || null;
  };

  const optionKey = (index) => `option${index + 1}`;

  const optionName = (option, index) => {
    if (typeof option === 'string') return option;
    return option?.name || `Option ${index + 1}`;
  };

  const productOptionNames = (product) => {
    const options = Array.isArray(product?.options) ? product.options : [];
    if (options.length) return options.map(optionName);

    const variants = Array.isArray(product?.variants) ? product.variants : [];
    return [0, 1, 2]
      .map((index) => (variants.some((variant) => variant?.[optionKey(index)]) ? `Option ${index + 1}` : ''))
      .filter(Boolean);
  };

  const optionValues = (product, index) => {
    const values = new Set();
    const key = optionKey(index);
    (Array.isArray(product?.variants) ? product.variants : []).forEach((variant) => {
      const value = variant?.[key];
      if (value) values.add(String(value));
    });
    return Array.from(values);
  };

  const variantMatchesSelections = (variant, selections) => Object.entries(selections)
    .every(([index, value]) => String(variant?.[optionKey(Number(index))] || '') === String(value));

  const variantFromSelections = (product, selections) => {
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    return variants.find((variant) => variantMatchesSelections(variant, selections)) || null;
  };

  const selectionsFromVariant = (product, variant) => {
    const selections = {};
    productOptionNames(product).forEach((_, index) => {
      const value = variant?.[optionKey(index)] || optionValues(product, index)[0];
      if (value) selections[index] = String(value);
    });
    return selections;
  };

  const optionIndexMatching = (product, matcher) => (
    productOptionNames(product).findIndex((name) => matcher.test(String(name || '')))
  );

  const selectedOptionValue = (product, selections, matcher) => {
    const index = optionIndexMatching(product, matcher);
    return index >= 0 ? selections[index] || '' : '';
  };

  const productHandle = (item) => {
    if (item.handle) return item.handle;
    if (item.product_handle) return item.product_handle;
    try {
      return new URL(item.url || '/', window.location.origin).pathname.split('/').filter(Boolean).pop() || '';
    } catch (_) {
      return '';
    }
  };

  const displayTitle = (item) => {
    const handle = productHandle(item);
    const byHandle = {
      'everyday-tunic-and-pants-set': window.zaT("Tunic Set"),
      'everyday-modest-tunic-set': window.zaT("Tunic Set"),
      'tailored-modest-two-piece-set': window.zaT("Collared Tunic Set"),
      'elegant-button-sleeve-tunic-pants-set': window.zaT("Button-Sleeve Set"),
      'relaxed-modest-lounge-set': window.zaT("Relaxed Shirt Set"),
      'soft-layered-modest-set': window.zaT("Layered Tunic Set"),
      'soft-pleated-abaya-dress': window.zaT("Gathered Abaya"),
      'abstract-print-maxi-dress': window.zaT("Abstract Maxi"),
      'graceful-button-maxi-dress': window.zaT("Ruffle-Hem Maxi"),
      'printed-flow-maxi-dress': window.zaT("Printed Tunic Set"),
    };
    if (byHandle[handle]) return byHandle[handle];

    return String(item.product_title || item.title || '')
      .replace('Everyday Button-Detail Tunic & Pants Set', 'Tunic Set')
      .replace('Tailored Collared Tunic & Wide-Leg Pants Set', 'Collared Tunic Set')
      .replace('Elegant Button-Sleeve Tunic & Pants Set', 'Button-Sleeve Set')
      .replace('Relaxed Button Shirt & Wide-Leg Pants Set', 'Relaxed Shirt Set')
      .replace('Soft Layered Button Tunic & Pants Set', 'Layered Tunic Set')
      .replace('Soft Gathered Abaya Maxi Dress', 'Gathered Abaya')
      .replace('Abstract Print Ruffle-Hem Maxi Dress', 'Abstract Maxi')
      .replace('Graceful Gathered Ruffle-Hem Maxi Dress', 'Ruffle-Hem Maxi')
      .replace('Printed Flow Tunic & Wide-Leg Pants Set', 'Printed Tunic Set');
  };

  const displayProductTitle = (product) => displayTitle({
    handle: product?.handle || '',
    product_handle: product?.handle || '',
    product_title: product?.title || '',
    title: product?.title || '',
    url: productUrl(product),
  });

  const setOpen = (open) => {
    if (!open) closeRecommendationPicker();
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('za-cart-drawer-open', open);
    triggers().forEach((trigger) => trigger.setAttribute('aria-expanded', open ? 'true' : 'false'));
    if (open) window.setTimeout(() => panel?.focus?.(), 50);
  };

  const updateCount = (count) => {
    document.querySelectorAll('[data-za-cart-count]').forEach((node) => {
      node.textContent = String(count);
      node.hidden = count === 0;
    });
  };

  const pulseCartTriggers = () => {
    triggers().forEach((trigger) => {
      trigger.classList.remove('is-cart-updated');
      void trigger.offsetWidth;
      trigger.classList.add('is-cart-updated');
      window.setTimeout(() => trigger.classList.remove('is-cart-updated'), 650);
    });
  };

  const setButtonFeedback = (button, state, label) => {
    if (!button) return;
    button.classList.remove('is-adding', 'is-added');
    if (state) button.classList.add(state);
    if (label) button.textContent = label;
  };

  const renderEmpty = () => {
    body.innerHTML = `
      <div class="za-cart-drawer__empty">
        <h3>${window.zaT("Your cart is empty")}</h3>
        
        <a href="${window.zaRoute("/collections/new-arrivals")}">${window.zaT("Shop new arrivals")}</a>
      </div>
    `;
    footer.hidden = true;
    if (progress) progress.style.width = '100%';
  };

  const renderUnavailable = () => {
    body.innerHTML = `
      <div class="za-cart-drawer__empty">
        <h3>${window.zaT("Your cart")}</h3>
        <p>${window.zaT("Cart details are taking longer to load. You can keep browsing or open the cart page.")}</p>
        <a href="${window.zaRoute("/cart")}" data-za-cart-view>${window.zaT("Open cart page")}</a>
      </div>
    `;
    footer.hidden = true;
    if (progress) progress.style.width = '100%';
  };

  const renderCartExtras = (cart) => {
    if (!isDesktopDrawer()) return '';
    const note = escapeHtml(cart.note || '');
    const noteExpanded = note ? ' is-expanded' : '';

    return `
      <section class="za-cart-drawer__note${noteExpanded}" data-za-cart-note-wrap>
        <label>
          <input type="checkbox" data-za-cart-note-toggle${note ? ' checked' : ''}>
          <span>${window.zaT("Add order notes")}</span>
        </label>
        <textarea rows="3" placeholder="${window.zaT("Add a delivery note")}" data-za-cart-note-input>${note}</textarea>
      </section>
      <section class="za-cart-drawer__recommendations" data-za-cart-recommendations hidden>
        <h3>${window.zaT("Complete the look")}</h3>
        <div class="za-cart-drawer__rec-picker" data-za-cart-rec-picker hidden></div>
        <div class="za-cart-drawer__recs" data-za-cart-recs></div>
      </section>
      <form class="za-cart-drawer__discount" data-za-cart-discount-form>
        <label for="ZaCartDrawerDiscount">${window.zaT("Discount code")}</label>
        <div>
          <input id="ZaCartDrawerDiscount" name="discount" type="text" autocomplete="off" placeholder="${window.zaT("DISCOUNT CODE")}">
          <button type="submit">${window.zaT("Apply")}</button>
        </div>
      </form>
    `;
  };

  const renderRecommendationCard = (product) => {
    const variant = firstAvailableVariant(product);
    if (!variant?.id) return '';
    const title = displayProductTitle(product);
    const image = recommendationImageUrl(product);
    // ZOALIN_CART_REC_DISCOUNT_20260909: use a matching variant price pair.
    const price = variant.price ?? product.price ?? product.price_min ?? 0;
    const comparePrice = Number(variant.compare_at_price || 0);
    const discount = comparePrice > Number(price) && Number(price) >= 0
      ? Math.round((comparePrice - Number(price)) * 100 / comparePrice) : 0;
    const badge = discount > 0 ? '<b class="za-cart-rec-discount">' + discount + '% off</b>' : '';
    const imageMarkup = image
      ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product?.title || title)}" loading="lazy">`
      : '';

    return `
      <article class="za-cart-drawer__rec">
        <a class="za-cart-drawer__rec-image" href="${escapeHtml(productUrl(product))}">${imageMarkup}</a>
        <div>
          <a href="${escapeHtml(productUrl(product))}">${escapeHtml(title)}</a>
          <span class="za-cart-rec-price">${formatMoney(price)}${badge}</span>
        </div>
        <button type="button" data-za-cart-rec data-product-handle="${escapeHtml(product.handle || '')}" data-variant-id="${escapeHtml(variant.id)}">${window.zaT("Add")}</button>
      </article>
    `;
  };

  const fetchProductByHandle = async (handle) => {
    const response = await fetch(`${root}products/${handle}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(window.zaT("Unable to load product"));
    return response.json();
  };

  const renderRecommendationPickerOptions = (product, selections) => productOptionNames(product)
    .map((name, index) => {
      const values = optionValues(product, index);
      if (!values.length) return '';

      return `
        <div class="za-cart-drawer__rec-option-group">
          <span>${escapeHtml(window.zaT(name))}</span>
          <div class="za-cart-drawer__rec-option-values">
            ${values.map((value) => `
              <button
                type="button"
                data-za-rec-option
                data-option-index="${index}"
                data-option-value="${escapeHtml(value)}"
                aria-pressed="${selections[index] === value ? 'true' : 'false'}"
              >${escapeHtml(window.zaProductOptionText(value))}</button>
            `).join('')}
          </div>
        </div>
      `;
    })
    .join('');

  const closeRecommendationPicker = () => {
    const picker = drawer.querySelector('[data-za-cart-rec-picker]');
    if (!picker) return;
    picker.hidden = true;
    picker.innerHTML = '';
    picker.style.top = '';
    picker.style.bottom = '';
    picker.style.right = '';
    picker.style.width = '';
    picker.style.removeProperty('--za-rec-picker-max-height');
    picker.removeAttribute('data-product-handle');
  };

  const positionRecommendationPicker = (picker, trigger) => {
    if (!picker) return;
    picker.style.top = '';
    picker.style.bottom = '';
    picker.style.right = '';
    picker.style.width = '';
    picker.style.removeProperty('--za-rec-picker-max-height');

    if (!isFloatingPicker()) {
      const row = trigger?.closest('.za-cart-drawer__rec');
      if (row) picker.style.top = `${Math.max(48, row.offsetTop - 4)}px`;
      return;
    }

    const panelRect = panel?.getBoundingClientRect();
    const drawerLeft = panelRect?.left ?? Math.max(0, window.innerWidth - 480);
    const viewportGap = 24;
    const drawerGap = 24;
    const availableWidth = Math.max(320, drawerLeft - viewportGap - drawerGap);
    const width = Math.min(460, availableWidth);
    const right = Math.max(viewportGap, window.innerWidth - drawerLeft + drawerGap);
    const maxHeight = Math.max(420, window.innerHeight - viewportGap);

    picker.style.top = 'auto';
    picker.style.bottom = '0px';
    picker.style.right = `${right}px`;
    picker.style.width = `${width}px`;
    picker.style.setProperty('--za-rec-picker-max-height', `${maxHeight}px`);
  };

  const updateRecommendationPicker = (picker) => {
    if (!picker) return;
    const product = recommendationProductMap.get(picker.dataset.productHandle || '');
    if (!product) return;

    const selections = {};
    picker.querySelectorAll('[data-za-rec-option][aria-pressed="true"]').forEach((button) => {
      selections[Number(button.dataset.optionIndex)] = button.dataset.optionValue || '';
    });

    const variant = variantFromSelections(product, selections);
    const addButton = picker.querySelector('[data-za-rec-picker-add]');
    if (!addButton) return;

    const canAdd = Boolean(variant?.id && variant.available !== false);
    const color = selectedOptionValue(product, selections, /colou?r/i);
    const image = variantImageUrl(product, variant);
    const price = variantPrice(product, variant);
    const imageNode = picker.querySelector('[data-za-rec-picker-image]');
    const priceNode = picker.querySelector('[data-za-rec-picker-price]');

    if (imageNode && image) {
      imageNode.src = image;
      imageNode.alt = color ? `${displayProductTitle(product)} in ${color}` : displayProductTitle(product);
    }
    if (priceNode) priceNode.textContent = formatMoney(price);
    addButton.dataset.variantId = variant?.id || '';
    addButton.disabled = !canAdd;
    addButton.textContent = canAdd ? window.zaT("Add to cart") : window.zaT("Sold out");
  };

  const renderRecommendationPicker = (product, trigger) => {
    const picker = drawer.querySelector('[data-za-cart-rec-picker]');
    if (!picker) return;

    const variant = firstAvailableVariant(product);
    const selections = selectionsFromVariant(product, variant);
    const title = displayProductTitle(product);
    const image = variantImageUrl(product, variant);
    const color = selectedOptionValue(product, selections, /colou?r/i);
    const price = variantPrice(product, variant);

    picker.dataset.productHandle = product.handle || '';
    picker.innerHTML = `
      <div class="za-cart-drawer__rec-picker-header">
        <strong>${window.zaT("Choose options")}</strong>
        <button type="button" data-za-rec-picker-close aria-label="${window.zaT("Close options")}">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
            <path d="M6 6l12 12M18 6 6 18"></path>
          </svg>
        </button>
      </div>
      <div class="za-cart-drawer__rec-picker-shell">
        <div class="za-cart-drawer__rec-picker-media">
          ${image ? `<img class="za-cart-drawer__rec-picker-image" data-za-rec-picker-image src="${escapeHtml(image)}" alt="${escapeHtml(color ? `${title} in ${color}` : title)}" loading="lazy">` : ''}
        </div>
        <div class="za-cart-drawer__rec-picker-main">
          <a class="za-cart-drawer__rec-picker-title" href="${escapeHtml(productUrl(product))}">${escapeHtml(title)}</a>
          <span class="za-cart-drawer__rec-picker-price" data-za-rec-picker-price>${formatMoney(price)}</span>
          <div class="za-cart-drawer__rec-options">
            ${renderRecommendationPickerOptions(product, selections)}
          </div>
          <button class="za-cart-drawer__rec-picker-add" type="button" data-za-rec-picker-add data-variant-id="${escapeHtml(variant?.id || '')}">${window.zaT("Add to cart")}</button>
        </div>
      </div>
    `;
    positionRecommendationPicker(picker, trigger);
    picker.hidden = false;
    updateRecommendationPicker(picker);
  };

  const openRecommendationPicker = async (button) => {
    const handle = button.dataset.productHandle || '';
    let product = recommendationProductMap.get(handle);

    if (!product && handle) {
      product = await fetchProductByHandle(handle);
      if (product?.handle) recommendationProductMap.set(product.handle, product);
    }

    if (!product) {
      if (button.dataset.variantId) await addVariant(button.dataset.variantId, button);
      return;
    }

    if (window.zaOpenProductPicker) {
      button.dataset.zaProductUrl = productUrl(product);
      button.dataset.zaProductTitle = displayProductTitle(product);
      const opened = await window.zaOpenProductPicker(button, () => { drawer.inert = false; button.focus(); });
      if (opened) drawer.inert = true;
      return;
    }
    renderRecommendationPicker(product, button);
  };

  const loadFallbackRecommendations = async (cartHandles) => {
    const handles = fallbackRecommendationHandles.filter((handle) => !cartHandles.has(handle));
    const settled = await Promise.allSettled(handles.slice(0, 5).map(fetchProductByHandle));
    return settled
      .filter((result) => result.status === 'fulfilled')
      .map((result) => result.value)
      .filter(Boolean)
      .slice(0, 3);
  };

  const hydrateRecommendations = async (cart) => {
    const wrap = drawer.querySelector('[data-za-cart-recommendations]');
    const recs = drawer.querySelector('[data-za-cart-recs]');
    if (!wrap || !recs || !isDesktopDrawer()) return;

    const cartHandles = new Set(cart.items.map(productHandle).filter(Boolean));
    const productId = cart.items.find((item) => item.product_id)?.product_id;
    let products = [];

    if (productId) {
      try {
        const response = await fetch(`${root}recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=3&intent=related`, {
          headers: { Accept: 'application/json' },
        });
        if (response.ok) {
          const payload = await response.json();
          products = Array.isArray(payload.products) ? payload.products : [];
        }
      } catch (_) {}
    }

    products = products
      .filter((product) => product?.handle && !cartHandles.has(product.handle))
      .slice(0, 3);

    if (products.length < 3) {
      try {
        const fallbackProducts = await loadFallbackRecommendations(cartHandles);
        products = products
          .concat(fallbackProducts.filter((product) => product?.handle && !products.some((current) => current.handle === product.handle)))
          .slice(0, 3);
      } catch (_) {}
    }

    recommendationProducts = products;
    recommendationProductMap.clear();
    recommendationProducts.forEach((product) => {
      if (product?.handle) recommendationProductMap.set(product.handle, product);
    });

    const markup = recommendationProducts.map(renderRecommendationCard).filter(Boolean).join('');
    if (!markup) {
      wrap.hidden = true;
      return;
    }

    recs.innerHTML = markup;
    wrap.hidden = false;
  };

  const shouldUseAsCartReturn = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      const path = url.pathname.replace(/\/+$/, '') || '/';
      return url.origin === window.location.origin
        && !/(^|\/)cart$/i.test(path)
        && !/(^|\/)checkouts?(\/|$)/i.test(path);
    } catch (_) {
      return false;
    }
  };

  const rememberCartReturn = () => {
    if (!shouldUseAsCartReturn(window.location.href)) return;
    try {
      window.sessionStorage.setItem(cartReturnKey, window.location.href);
    } catch (_) {}
  };

  // Compare prices are loaded from the exact selected variants, in the active market.
  let priceRenderVersion = 0;
  const linePriceInfo = (item, product) => {
    const variant = product?.variants?.find(v => String(v.id) === String(item.variant_id));
    const original = Number(item.original_price ?? item.price ?? item.final_price ?? 0);
    const compare = Number(variant?.compare_at_price || 0);
    const regular = Math.max(compare, original);
    const discount = compare > original && original > 0 ? Math.round((compare-original)*100/compare) : 0;
    return { regular, discount, final: Number(item.final_price ?? original) };
  };
  const linePriceHtml = (item, product) => {
    const info = linePriceInfo(item, product);
    const old = info.regular > info.final ? '<s class="za-drawer-regular">'+formatMoney(info.regular)+'</s>' : '';
    const badge = info.discount > 0 ? '<b class="za-drawer-discount">'+info.discount+'% off</b>' : '';
    return old+'<span class="za-drawer-current">'+formatMoney(info.final)+'</span>'+badge;
  };
  const hydrateLinePrices = async (cart, version) => {
    const handles = [...new Set(cart.items.map(i => i.handle).filter(Boolean))];
    const results = await Promise.allSettled(handles.map(currentProductByHandle));
    if (version !== priceRenderVersion) return;
    const products = new Map();
    results.forEach((result, index) => { if (result.status === 'fulfilled') products.set(handles[index], result.value); });
    let regularTotal = 0;
    let complete = true;
    cart.items.forEach((item, index) => {
      const product = products.get(item.handle);
      if (!product?.variants?.some(v => String(v.id) === String(item.variant_id))) complete = false;
      const node = body.querySelector('[data-za-line-price="'+index+'"]');
      if (node) node.innerHTML = linePriceHtml(item, product);
      regularTotal += linePriceInfo(item, product).regular * item.quantity;
    });
    subtotal.innerHTML = (complete && regularTotal > cart.total_price ? '<s class="za-drawer-regular">'+formatMoney(regularTotal)+'</s>' : '')+'<span>'+formatMoney(cart.total_price)+'</span>';
  };

  const renderItems = (cart) => {
    const priceVersion = ++priceRenderVersion;
    const itemsHtml = cart.items.map((item, index) => {
      const itemDisplayTitle = displayTitle(item);
      const removeLabel = escapeHtml(document.documentElement.lang === "ar" ? `إزالة ${itemDisplayTitle} من السلة` : document.documentElement.lang === "fr" ? `Retirer ${itemDisplayTitle} du panier` : `${window.zaT("Remove")} ${itemDisplayTitle} ${window.zaT("from cart")}`);
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p>${escapeHtml(window.zaVariantDisplayText(item.variant_title))}</p>`
        : '';
      const thumbnailPriority = index < 3
        ? 'loading="eager" fetchpriority="high"'
        : 'loading="lazy" fetchpriority="auto"';
      const image = item.image
        ? `<img src="${escapeHtml(imageUrl(item.image, 320))}" alt="${escapeHtml(item.product_title)}" ${thumbnailPriority} decoding="async" data-za-cart-line-image="${index}">`
        : '';
      return `
        <article class="za-cart-drawer__item">
          <a class="za-cart-drawer__item-image" href="${escapeHtml(item.url)}">${image}</a>
          <div class="za-cart-drawer__item-main">
            <a class="za-cart-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(itemDisplayTitle)}</a>
            ${variant}
            <span class="za-drawer-unit-price" data-za-line-price="${index}">${linePriceHtml(item)}</span>
            <div class="za-cart-drawer__qty-row">
              <div class="za-cart-drawer__qty" aria-label="${document.documentElement.lang === "ar" ? "كمية" : document.documentElement.lang === "fr" ? "Quantité pour" : window.zaT("Quantity for")} ${escapeHtml(itemDisplayTitle)}">
                <button type="button" data-za-cart-change data-key="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="${window.zaT("Decrease quantity")}">-</button>
                <span>${item.quantity}</span>
                <button type="button" data-za-cart-change data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="${window.zaT("Increase quantity")}">+</button>
              </div>
              <button class="za-cart-drawer__remove za-cart-drawer__remove--mobile" type="button" data-za-cart-change data-key="${escapeHtml(item.key)}" data-quantity="0" aria-label="${removeLabel}">${trashIcon}</button>
            </div>
          </div>
          <div class="za-cart-drawer__item-side">
            <strong>${formatMoney(item.final_line_price)}</strong>
            <button class="za-cart-drawer__remove za-cart-drawer__remove--desktop" type="button" data-za-cart-change data-key="${escapeHtml(item.key)}" data-quantity="0" aria-label="${removeLabel}">${trashIcon}</button>
          </div>
        </article>
      `;
    }).join('');

    body.innerHTML = `<div class="za-cart-drawer__items">${itemsHtml}</div>${renderCartExtras(cart)}`;
    if (subtotalLabel) {
      const itemLabel = cart.item_count === 1 ? window.zaT("item") : window.zaT("items");
      subtotalLabel.textContent = ["ar","fr","ms","es","it"].includes(document.documentElement.lang) ? window.zaT("Subtotal") + " (" + window.zaItemCount(cart.item_count) + ")" : isDesktopDrawer() ? `${window.zaT("Subtotal")} (${cart.item_count} ${itemLabel})` : window.zaT("Subtotal");
    }
    subtotal.textContent = formatMoney(cart.total_price);
    footer.hidden = false;
    if (progress) progress.style.width = '100%';
    hydrateLinePrices(cart, priceVersion).catch(() => {});
    hydrateRecommendations(cart).catch(() => {});
  };

  const render = (cart) => {
    updateCount(cart.item_count || 0);
    if (!cart.item_count) { priceRenderVersion++; renderEmpty(); }
    else renderItems(cart);
    hasRenderedCart = true;
    document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart } }));
  };

  const fetchCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(window.zaT("Unable to load cart"));
    return response.json();
  };

  const refreshCart = async () => {
    if (isLoading) return;
    isLoading = true;
    const showLoadingState = !hasRenderedCart;
    if (showLoadingState) body.classList.add('is-loading');
    try {
      render(await fetchCart());
    } finally {
      if (showLoadingState) body.classList.remove('is-loading');
      isLoading = false;
    }
  };

  const changeItem = async (key, quantity) => {
    body.classList.add('is-loading');
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Number(quantity) }),
      });
      if (!response.ok) throw new Error(window.zaT("Unable to update cart"));
      render(await response.json());
    } finally {
      body.classList.remove('is-loading');
    }
  };

  const updateCartNote = async (note) => {
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note }),
    });
    if (!response.ok) throw new Error(window.zaT("Unable to update note"));
    return response.json();
  };

  const addVariant = async (variantId, button) => {
    button.disabled = true;
    const original = button.textContent;
    button.textContent = window.zaT("Adding");
    const shouldOpen = button.hasAttribute('data-za-cart-open-after-add');
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });
    if (!response.ok) throw new Error(window.zaT("Unable to add item"));
    await refreshCart().catch(renderUnavailable);
    if (shouldOpen) setOpen(true);
    button.textContent = window.zaT("Added");
    window.setTimeout(() => {
      button.disabled = false;
      button.textContent = original;
    }, 900);
  };

  const addProductForm = async (form, submitter) => {
    if (!form) return;
    const button = submitter || form.querySelector('button[type="submit"], [name="add"]');
    const original = button ? button.textContent.trim() : '';
    if (button) {
      button.disabled = true;
      setButtonFeedback(button, 'is-adding', window.zaT("Adding..."));
    }

    const formData = new FormData(form);
    if (!formData.get('quantity')) formData.set('quantity', '1');

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const payload = await response.json().catch(() => null);
      if (!response.ok) throw new Error(payload?.description || window.zaT("Unable to add item"));
      document.dispatchEvent(new CustomEvent('zoalin:quick-add:added', { detail: { payload } }));
      await refreshCart().catch(renderUnavailable);
      pulseCartTriggers();
      setButtonFeedback(button, 'is-added', window.zaT("Added to cart"));
    } finally {
      window.setTimeout(() => {
        if (button) {
          button.disabled = false;
          button.classList.remove('is-adding', 'is-added');
          button.textContent = original || window.zaT("Add to cart");
        }
      }, 1150);
    }
  };

  const syncMobileBuybar = () => {
    if (!mobileBuybar) return;
    const form = document.querySelector('form.za-product__form');
    const select = form?.querySelector('[data-za-variant-select], select[name="id"]');
    const price = mobileBuybar.querySelector('[data-za-mobile-buybar-price]');
    const option = mobileBuybar.querySelector('[data-za-mobile-buybar-option]');
    const button = mobileBuybar.querySelector('[data-za-mobile-buybar-submit]');
    const addButton = form?.querySelector('button[type="submit"]');
    const selected = select?.selectedOptions?.[0];

    if (price && selected?.dataset?.wishlistPrice) price.textContent = selected.dataset.wishlistPrice;
    if (option && selected) option.textContent = selected.textContent.replace(/\s+-\s+Sold out\s*$/i, '').trim();
    if (button && addButton) {
      button.disabled = addButton.disabled || Boolean(selected?.disabled);
      button.textContent = button.disabled ? window.zaT("Sold out") : window.zaT("Add to cart");
    }
  };

  document.addEventListener('click', async (event) => {
    const openTrigger = event.target.closest('[data-za-cart-drawer-open]');
    if (openTrigger && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      setOpen(true);
      if (!hasRenderedCart) await refreshCart().catch(renderUnavailable);
      return;
    }

    if (event.target.closest('[data-za-cart-drawer-close]')) {
      event.preventDefault();
      setOpen(false);
      return;
    }

    if (event.target.closest('[data-za-cart-view]')) {
      rememberCartReturn();
      setOpen(false);
      return;
    }

    const change = event.target.closest('[data-za-cart-change]');
    if (change) {
      event.preventDefault();
      await changeItem(change.dataset.key, change.dataset.quantity).catch(refreshCart);
      return;
    }

    const rec = event.target.closest('[data-za-cart-rec]');
    if (rec) {
      event.preventDefault();
      await openRecommendationPicker(rec).catch(() => {
        rec.disabled = false;
        rec.textContent = window.zaT("Try again");
      });
      return;
    }

    const pickerClose = event.target.closest('[data-za-rec-picker-close]');
    if (pickerClose) {
      event.preventDefault();
      closeRecommendationPicker();
      return;
    }

    const pickerOption = event.target.closest('[data-za-rec-option]');
    if (pickerOption) {
      event.preventDefault();
      pickerOption.closest('.za-cart-drawer__rec-option-values')
        ?.querySelectorAll('[data-za-rec-option]')
        .forEach((button) => button.setAttribute('aria-pressed', 'false'));
      pickerOption.setAttribute('aria-pressed', 'true');
      updateRecommendationPicker(pickerOption.closest('[data-za-cart-rec-picker]'));
      return;
    }

    const pickerAdd = event.target.closest('[data-za-rec-picker-add]');
    if (pickerAdd) {
      event.preventDefault();
      const variantId = pickerAdd.dataset.variantId;
      if (!variantId) return;
      await addVariant(variantId, pickerAdd).catch(() => {
        pickerAdd.disabled = false;
        pickerAdd.textContent = window.zaT("Try again");
      });
      return;
    }

    const stickySubmit = event.target.closest('[data-za-mobile-buybar-submit]');
    if (stickySubmit) {
      event.preventDefault();
      const form = document.querySelector('form.za-product__form');
      await addProductForm(form, stickySubmit).catch(() => {
        stickySubmit.disabled = false;
        stickySubmit.textContent = window.zaT("Try again");
      });
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.matches('[data-za-cart-discount-form]')) {
      event.preventDefault();
      const code = String(new FormData(form).get('discount') || '').trim();
      if (code) window.location.href = `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(window.zaCheckoutUrl(root + 'checkout'))}`;
      return;
    }

    if (!form.matches('form.za-product__form')) return;
    event.preventDefault();
    await addProductForm(form, event.submitter).catch(() => {
      const button = event.submitter || form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = false;
        button.textContent = window.zaT("Try again");
      }
    });
  });

  document.addEventListener('change', async (event) => {
    const noteToggle = event.target.closest?.('[data-za-cart-note-toggle]');
    if (noteToggle) {
      const wrap = noteToggle.closest('[data-za-cart-note-wrap]');
      const input = wrap?.querySelector('[data-za-cart-note-input]');
      wrap?.classList.toggle('is-expanded', noteToggle.checked);
      if (!noteToggle.checked && input) {
        input.value = '';
        await updateCartNote('').catch(() => {});
      } else {
        input?.focus();
      }
      return;
    }

    if (event.target.closest?.('form.za-product__form')) syncMobileBuybar();
  });

  document.addEventListener('blur', (event) => {
    const noteInput = event.target.closest?.('[data-za-cart-note-input]');
    if (noteInput) updateCartNote(noteInput.value).catch(() => {});
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || drawer.inert || !drawer.classList.contains('is-open')) return;
    const picker = drawer.querySelector('[data-za-cart-rec-picker]');
    if (picker && !picker.hidden) {
      closeRecommendationPicker();
      return;
    }
    setOpen(false);
  });

  document.addEventListener('zoalin:cart:refresh-open', async () => {
    await refreshCart().catch(() => { window.location.href = window.zaRoute('/cart'); });
    setOpen(true);
  });

  document.addEventListener('zoalin:cart:refresh', () => {
    refreshCart().catch(() => {});
  });

  window.addEventListener('resize', () => {
    const picker = drawer.querySelector('[data-za-cart-rec-picker]');
    if (!picker || picker.hidden) return;
    const handle = picker.dataset.productHandle || '';
    const trigger = Array.from(drawer.querySelectorAll('[data-za-cart-rec]'))
      .find((button) => button.dataset.productHandle === handle);
    positionRecommendationPicker(picker, trigger);
  });

  const initialCart = (() => {
    try {
      return initialCartData?.textContent ? JSON.parse(initialCartData.textContent) : null;
    } catch (_) {
      return null;
    }
  })();
  if (initialCart && Array.isArray(initialCart.items)) render(initialCart);
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshCart, { once: true });
  else refreshCart();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncMobileBuybar, { once: true });
  else syncMobileBuybar();
})();


